import Axios from "axios";
import { ROOT_URL } from "../../config";

export const axios = Axios.create({
  // [TODO] baseURLの設定は保留
  // baseURL: ROOT_URL,
});
